<template>
  <div class="text-subtitle-1 font-weight-bold">
    <div class="d-flex flex-wrap flex-start">
      <div v-if="show_places_restantes">
        <span> {{ places_restantes }} place(s) restante(s)</span>
        <span class="text-primary-dark mx-1">|</span>
      </div>

      <div v-if="course.metadatas?.discipline != 'Non sportif'">
        <span> {{ course.metadatas.discipline }}</span>
        <span class="text-primary-dark mx-1">|</span>
      </div>
      <div v-if="show_is_chrono">
        <span> {{ course.metadatas.est_chronometre == "0" ? "Non chronométré" : "Chronométré" }}</span>
        <span class="text-primary-dark mx-1">|</span>
      </div>
      <div v-if="course.metadatas?.distance != '0'">
        <span> {{ course.metadatas.distance }}KM</span>
        <span class="text-primary-dark mx-1">|</span>
      </div>
      <div v-if="course.metadatas?.denivele != ''">
        <span> {{ course.metadatas.denivele }}m D+</span>
        <span class="text-primary-dark mx-1">|</span>
      </div>
      <div v-if="course.metadatas?.naissance_min != ''">
        <span> {{ "Né après le " + $moment(course.metadatas.naissance_min).format("DD/MM/YYYY") }}</span>
        <span class="text-primary-dark mx-1">|</span>
      </div>
      <div v-if="course.metadatas?.naissance_max != ''">
        <span> {{ "Né avant le " + $moment(course.metadatas.naissance_max).format("DD/MM/YYYY") }}</span>
        <span class="text-primary-dark mx-1">|</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
  props: ["course"],
  computed: {
    ...mapStores(useMainStore),
    places_restantes() {
      return this.course.get_places_restantes(this.mainStore.module.courses);
    },
    has_places_restantes() {
      return this.places_restantes > 0;
    },
    show_places_restantes() {
      const course_has_max = this.course.has_max_inscrits();
      const hide_inscrits = this.mainStore.module.hide_nb_inscrits;
      return course_has_max && !hide_inscrits && this.has_places_restantes;
    },
    show_is_chrono() {
      const meta_exist = this.course.metadatas?.est_chronometre;
      const is_sportif = this.course.metadatas?.discipline != 'Non sportif';
      const is_pacours_billetterie = this.mainStore.parcours_billetterie_mode;
      return meta_exist && is_sportif && !is_pacours_billetterie;

    },
  },
  methods: {
  },
};
</script>

<style lang="scss"></style>